import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { formatCurrency, formatNumber } from './promotion-report-format';

const tooltipFormatter = (value, name) =>
  name === 'Discount'
    ? [formatCurrency(value), name]
    : [formatNumber(value), name];

export default function PromotionTrendChart({ dailyTrend = [], timezone }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Daily Trend</CardTitle>
        <p className="text-sm text-muted-foreground">
          Days are bucketed in {timezone || 'the store timezone'}.
        </p>
      </CardHeader>
      <CardContent>
        {dailyTrend.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            No data for this period
          </div>
        ) : (
          <div style={{ width: '100%', height: 320 }}>
            <ResponsiveContainer>
              <LineChart
                data={dailyTrend}
                margin={{ top: 8, right: 16, bottom: 8, left: 8 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                <YAxis
                  yAxisId="discount"
                  tick={{ fontSize: 12 }}
                  tickFormatter={(value) => formatCurrency(value)}
                />
                <YAxis
                  yAxisId="usage"
                  orientation="right"
                  tick={{ fontSize: 12 }}
                  allowDecimals={false}
                />
                <Tooltip formatter={tooltipFormatter} />
                <Legend />
                <Line
                  yAxisId="discount"
                  type="monotone"
                  dataKey="totalDiscount"
                  name="Discount"
                  strokeWidth={2}
                  dot={false}
                />
                <Line
                  yAxisId="usage"
                  type="monotone"
                  dataKey="usageCount"
                  name="Usages"
                  strokeWidth={2}
                  strokeDasharray="4 3"
                  dot={false}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
